import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LandingPageComponent as LandingPageUIComponent } from '@com-delta-idp/mnx-skymiles-landing-page-ui';
import { SharedModule } from '@com-delta-idp/mnx-skymiles-shared';
import { PushPipe } from '@ngrx/component';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { LandingPageEffects } from './data-access/+state/effects/landing-page.effects';
import * as fromLandingPage from './data-access/+state/reducers/landing-page.reducer';
import { LandingPageComponent } from './entry-components/landing-page/landing-page.component';
import { SkeletonLoaderDirective } from '@com-delta-omnichannel/aura';

@NgModule({
  declarations: [LandingPageComponent],
  imports: [
    CommonModule,
    LandingPageUIComponent,
    PushPipe,
    StoreModule.forFeature(
      fromLandingPage.LANDING_PAGE_FEATURE_KEY,
      fromLandingPage.reducer
    ),
    EffectsModule.forFeature([LandingPageEffects]),
    SharedModule,
    SkeletonLoaderDirective
  ],
  exports: [LandingPageComponent]
})
export class SmartModule {}
